<dxc-textarea
  label="{{ label | translate }}"
  helperText="{{ helperText | translate }}"
  placeholder="{{ placeholder | translate }}"
  id="id"
  [disabled]="disabled"
  [value]="value"
  verticalGrow="verticalGrow"
  (onChange)="onChange($event)"
  (onBlur)="onBlur($event)"
  [size]="size"
  [margin]="margin"
  [error]="errorMessage"
  [maxLength]="maxLength"
  [minLength]="minLength"
  [class.required]="required"
  [rows]="rows"
>
</dxc-textarea>
